import { PageContainer } from '@if/mui'
import LoanCreateWizard from '@src/components/LoanCreateWizard/LoanCreateWizard'
import { useTranslation } from 'react-i18next'

const LoanCreatePage = () => {
  const { t } = useTranslation()
  return (
    <PageContainer back={{ to: '/loans', label: t('loan.title') }} title={t('loan.create.title')}>
      <LoanCreateWizard />
    </PageContainer>
  )
}

export default LoanCreatePage
